import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const EMBED_MODE_KEY = 'intellix_embed_mode';

/**
 * 检测当前是否处于嵌入模式
 * - 首次访问时从 URL 参数 mode=embed 读取并保存到 sessionStorage
 * - 后续访问从 sessionStorage 读取，保证二级页面也能正确识别
 */
export function useEmbedMode() {
  const [searchParams] = useSearchParams();
  const urlIsEmbed = searchParams.get('mode') === 'embed';

  const [isEmbed, setIsEmbed] = useState(() => {
    // 初始化时优先检查 URL，否则读取 sessionStorage
    if (urlIsEmbed) {
      sessionStorage.setItem(EMBED_MODE_KEY, 'true');
      return true;
    }
    return sessionStorage.getItem(EMBED_MODE_KEY) === 'true';
  });

  useEffect(() => {
    if (urlIsEmbed) {
      sessionStorage.setItem(EMBED_MODE_KEY, 'true');
      setIsEmbed(true);
    }
  }, [urlIsEmbed]);
  console.log('useEmbedMode', isEmbed);
  
  return isEmbed;
}
